import React from "react";
import Layout from "../Layout/Layout";
import "./MainContent.css";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { BiBarChart, BiTimeFive, BiBell } from "react-icons/bi";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { FaPlus, FaClock, FaProjectDiagram } from "react-icons/fa";
import { useNavigate } from "react-router-dom";  // ✅ Import useNavigate

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const MainContent = () => {
  const navigate = useNavigate(); // ✅ Hook for navigation

  const graphData = [
    { label: "Total Studies", value: 120, color: "#4CAF50" },
    { label: "Pending Reviews", value: 45, color: "#FFA500" },
    { label: "Alerts", value: 30, color: "#FF4500" },
    { label: "Risk Scores", value: 75, color: "#1E90FF" },
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { backgroundColor: "rgba(0,0,0,0.8)" },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true },
    },
    animation: {
      duration: 1000,
      easing: "easeInOutCubic",
    },
  };

  return (
   <div>
      {/* section-1 */}
      <section>
        <h2 className="heading">Summary Cards</h2>
        <div className="card-container">
          <Card className="card1" style={{ width: "15rem" }}>
            <Card.Body>
              <Card.Title className="title">
                <BiBarChart className="card-icon" /> Draft
              </Card.Title>
            </Card.Body>
          </Card>

          <Card className="card1" style={{ width: "20rem" }}>
            <Card.Body>
              <Card.Title className="title">
                <BiTimeFive className="card-icon" /> Submitted
              </Card.Title>
            </Card.Body>
          </Card>

          <Card className="card1" style={{ width: "20rem" }}>
            <Card.Body>
              <Card.Title className="title">
                <BiBell className="card-icon" /> Approved Studies
              </Card.Title>
            </Card.Body>
          </Card>
        </div>
      </section>

      {/* section-2 for bar graphs */}
      <section>
        <h2 className="heading">Overview Widgets</h2>
        <div className="dashboard-container">
          {graphData.map((data, index) => (
            <div key={index} className="graph-card">
              <h3 className="graph-title">{data.label}</h3>
              <Bar
                data={{
                  labels: [data.label],
                  datasets: [
                    {
                      label: data.label,
                      data: [data.value],
                      backgroundColor: data.color,
                      borderRadius: 8,
                    },
                  ],
                }}
                options={options}
              />
            </div>
          ))}
        </div>
      </section>

      {/* section-3 for quick links */}
      <section>
        <h2 className="heading">Quick Links</h2>
        <div className="quick-links-container">
          {/* Create New Studies */}
          <div className="quick-link" onClick={() => alert("Creating New Study")}>
            <div className="icon-wrapper">
              <FaPlus className="icon1" />
            </div>
            <h3>Create New Studies</h3>
          </div>

          {/* View Recent Activities */}
          <div className="quick-link" onClick={() => alert("Viewing Recent Activities")}>
            <div className="icon-wrapper">
              <FaClock className="icon1" />
            </div>
            <h3>View Recent Activities</h3>
          </div>

          {/* ✅ HAZOP Worksheet Link */}
          <div className="quick-link" onClick={() => navigate("/node-creation")}>
            <div className="icon-wrapper">
              <FaProjectDiagram className="icon1" />
            </div>
            <h3>HAZOP Worksheet</h3>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MainContent;
